<div class="flashcard-widget">
  <div class="content-wrapper" [ngClass]="side" [innerHtml]="side === 'front' ? flashcard.question : flashcard.answer"></div>
</div>